import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from "swiper";
import BuyButton from './BuyButton';

import 'swiper/css';
import "swiper/css/navigation";
import "swiper/css/pagination";

import './BlockSlider.scss';

const BlockSlider: React.FC = () => {
    
    return (
        <div className="block-slider">
            <div className="slider-wrap">
                <Swiper
                    navigation={true} 
                    pagination={true}
                    modules={[Navigation, Pagination]}
                    slidesPerView={1}
                >
                    <SwiperSlide><img src="/img/slider/slider1_1.jpg" alt="" /></SwiperSlide>
                    <SwiperSlide><img src="/img/slider/slider2_1.jpg" alt="" /></SwiperSlide>
                    <SwiperSlide><img src="/img/slider/slider3_1.jpg" alt="" /></SwiperSlide>
                    <SwiperSlide><img src="/img/slider/slider4_1.jpg" alt="" /></SwiperSlide>
                    <SwiperSlide><img src="/img/slider/slider5_1.jpg" alt="" /></SwiperSlide>
                </Swiper>
            </div>
            

            <div className="text-center button-box">
                <BuyButton />
            </div>
        </div>
    );
};

export default BlockSlider;